import React from "react";
import { Paper, Typography } from "@mui/material";

// Define the Notification interface
interface NotificationProps {
  id: number;
  user_id: number;
  notification_type: string;
  message: string;
  status: "unread" | "read";
  created_at: string; // or Date if you prefer to handle it as a Date object
}

const Notification: React.FC<{ notification: NotificationProps }> = ({
  notification,
}) => {
  return (
    <Paper
      elevation={2}
      sx={{
        padding: 2,
        maxWidth: "385px",
        marginBottom: 0.3,
        cursor: "pointer", // Change cursor to pointer
        "&:hover": {
          backgroundColor: (theme) => theme.palette.action.hover, // Darker background on hover
        },
      }}
    >
      <Typography variant="body1">{notification.message}</Typography>
      <Typography variant="caption" color="textSecondary">
        {new Date(notification.created_at).toLocaleString()}
      </Typography>
    </Paper>
  );
};

export default Notification;
